<template>
    <!-- 在途板材 -->
    <!-- <div class="templete_box">
        <div class="crumbsNav clearfix no_print">
            <div class="navSon navSonChecked" v-if="categoryBoardType">
            </div>
            <div class="navSon" v-if="categoryRawType">
                在途原木
            </div>
            <div class="navSon" v-if="categoryScrapType">
                在途集成材
            </div>
        </div> -->
        <div class="templete">
            <div class="search_box clearfix no_print">
                <el-input class="search_input search_inputBox" v-model="params.container_no" placeholder="货柜号" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectWarehouseList('supplier_id')">
                    <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" filterable @visible-change="getSelectWarehouseList('breed_id')">
                    <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" filterable @visible-change="getSelectWarehouseList('brand_id')">
                    <el-option v-for="list in selectMapC.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.thickness" multiple collapse-tags placeholder="厚度" filterable @visible-change="getSelectWarehouseList('original_thickness')">
                    <el-option v-for="(list,index) in selectMapC.original_thickness" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.length" multiple collapse-tags placeholder="长度" filterable @visible-change="getSelectWarehouseList('original_length')">
                    <el-option v-for="(list,index) in selectMapC.original_length" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.grade_id" multiple collapse-tags placeholder="等级" filterable @visible-change="getSelectWarehouseList('grade_id')">
                    <el-option v-for="list in selectMapC.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.bale_no" placeholder="捆包号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.original_bale" placeholder="供单号" size="mini"></el-input>
                <!-- <div class="search_time search_inputBox">
                    <el-date-picker v-model="inbound_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入库时间"></el-date-picker>
                </div> -->
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.warehouse_id" multiple collapse-tags placeholder="仓库" filterable @visible-change="getSelectWarehouseList('warehouse_id')">
                    <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <!-- <div class="search_time search_inputBox">
                    <el-input v-model="params.price_min" placeholder="价格区间" size="mini"></el-input>
                    ~
                    <el-input v-model="params.price_max" placeholder="价格区间" size="mini"></el-input>
                </div> -->
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.opening_company_id" placeholder="货权单位" filterable @visible-change="getSelectList('opencompany')">
                    <el-option v-for="list in selectMap.opencompany" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.contract_no" placeholder="合同号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.bill_lading_no" placeholder="提单号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.storage_age" placeholder="库龄" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.storage_location" placeholder="库位" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.attribute_id" multiple collapse-tags placeholder="属性" filterable @visible-change="getSelectWarehouseList('attribute_id')">
                    <el-option v-for="list in selectMapC.attribute_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.color_id" multiple collapse-tags placeholder="选色" filterable @visible-change="getSelectWarehouseList('color_id')">
                    <el-option v-for="list in selectMapC.color_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.purchase_type" placeholder="采购类型">
                    <el-option :value="0" label="合同采购"></el-option>
                    <el-option :value="1" label="云链采购"></el-option>
                    <el-option :value="2" label="市场调货"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.check_status" placeholder="检尺状态">
                    <el-option :value="999" label="全部检尺状态"></el-option>
                    <el-option :value="1" label="已检尺"></el-option>
                    <el-option :value="0" label="未检尺"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.remark" placeholder="备注" size="mini"></el-input>
                <!-- <el-select class="search_select search_inputBox" v-model="params.port_id" multiple collapse-tags placeholder="目的港">
                    <el-option v-for="list in portList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select> -->
                <!-- <el-input class="search_input search_inputBox" v-model="params.container_no" placeholder="货柜号" size="mini"></el-input> -->
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                    <div class="reset fcolor" style="margin: 0 20px;">
                        <el-checkbox v-model="is_like">精确查找</el-checkbox>
                    </div>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                </div>
            </div>
            <div class="btnList clearfix no_print">
                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',purchase-report-road-check,')!=-1" @click="chi">检尺</el-button>
                <el-button class="funcPublicBtn" v-if="module.indexOf(',purchase-report-batch-check,')!=-1" @click="bachChi">批量检尺</el-button>
                <el-button class="funcPublicBtn" v-if="module.indexOf(',purchase-report-road-print,')!=-1" @click="printTip">打印标签</el-button>
                <!-- <el-button class="funcPublicBtn">新增销售单</el-button> -->
                <el-button class="funcPublicBtn" v-if="module.indexOf(',purchase-report-road-update,')!=-1" @click="batchEdit">批量修改</el-button>
                <el-button class="funcPublicBtn" v-if="module.indexOf(',purchase-report-road-delete,')!=-1" @click="batchDel">批量删除</el-button>
                <el-button class="funcPublicBtn" v-if="module.indexOf(',purchase-report-road-instore,')!=-1" @click="confirm">确认入库</el-button>
            </div>
            <div class="tableBox no_print">
                <tabletem :isSetCol="true" scene="inventory.transit" @sortTable="sortTable" :isLoading="tableLoading" :tablecol="tableCol" :isShowIndex="true" :tabledata="list" @getRow="getRow" @getTableDelete="getTableDelete" @getTableSee="getTableSee" @getTableEdit="getTableEdit" @rowClick="rowClick"></tabletem>
            </div>
            <div class="totalCal no_print">
                <div class="totalName">合计：</div>
                <div class="totalNumber">选定立方:{{selectTotalCube}}</div>
                <div class="totalNumber">合计件数:{{totalObj.numbers}}</div>
                <div class="totalNumber">合计立方:{{totalObj.cube_total}}</div>
            </div>
            <div class="pageBox no_print">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <!-- 修改库存START -->
            <el-dialog v-dialog-drag :visible.sync="dialogVisibleSet" class="eldialog eldialogA" width="630px" :modal="false" title="修正原始码单数据" custom-class="full_dialog">
                <el-form ref="editForm" :model="editForm" class="clearfix">
                    <div class="eldialogFormBox">
                        <!-- <el-form-item  label="入库日期：" prop="inbound_time">
                            <el-date-picker v-model="editForm.inbound_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item> -->
                        <el-form-item  label="捆包号：" prop="bale_no">
                            <el-input v-model="editForm.bale_no"></el-input>
                        </el-form-item>
                        <el-form-item  label="供应商：" prop="supplier_id">
                            <el-select v-model="editForm.supplier_id" @visible-change="getSelectList('supplier')" filterable>
                                <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="品名：" prop="breed_id">
                            <el-select v-model="editForm.breed_id" @visible-change="getSelectList('breed')">
                                <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="品牌：" prop="brand_id">
                            <el-select v-model="editForm.brand_id" @visible-change="getSelectList('brand')">
                                <el-option v-for="list in selectMap.brand" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="厚度：" prop="original_thickness">
                            <el-input v-model="editForm.original_thickness"></el-input>
                        </el-form-item>
                        <el-form-item  label="长度：" prop="original_length">
                            <el-input v-model="editForm.original_length"></el-input>
                        </el-form-item>
                        <el-form-item  label="厚度mm：" prop="thickness_formula">
                            <el-input v-model="editForm.thickness_formula" :disabled="editCategory"></el-input>
                        </el-form-item>
                        <el-form-item  label="长度m：" prop="length_formula">
                            <el-input v-model="editForm.length_formula" :disabled="editCategory"></el-input>
                        </el-form-item>
                        <el-form-item  label="等级：" prop="grade_id">
                            <el-select v-model="editForm.grade_id" @visible-change="getSelectList('grade')">
                                <el-option v-for="list in selectMap.grade" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="片数：" prop="pieces">
                            <el-input v-model="editForm.pieces"></el-input>
                        </el-form-item>
                        <el-form-item  label="码单立方：" prop="original_cube">
                            <el-input v-model="editForm.original_cube"></el-input>
                        </el-form-item>
                        <el-form-item  label="挂牌价：" prop="sales_price">
                            <el-input v-model="editForm.sales_price"></el-input>
                        </el-form-item>
                        <el-form-item  label="供单号：" prop="original_bale">
                            <el-input v-model="editForm.original_bale"></el-input>
                        </el-form-item>
                        <el-form-item  label="合同号：" prop="contract_no">
                            <el-input v-model="editForm.contract_no"></el-input>
                        </el-form-item>
                        <el-form-item  label="目的港：" prop="port_id">
                            <el-select v-model="editForm.port_id" @visible-change="getSelectList('port')">
                                <el-option v-for="list in selectMap.port" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="提单号：" prop="bill_lading_no">
                            <el-input v-model="editForm.bill_lading_no"></el-input>
                        </el-form-item>
                        <el-form-item  label="预计入库：" prop="expected_storage_time">
                            <el-date-picker v-model="editForm.expected_storage_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                        <el-form-item  label="货柜号：" prop="container_no">
                            <el-input v-model="editForm.container_no"></el-input>
                        </el-form-item>
                        <el-form-item  label="预计到港：" prop="expected_arrival_time">
                            <el-date-picker v-model="editForm.expected_arrival_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                        <!-- <el-form-item  label="采购单价：" prop="cube_price">
                            <el-input v-model="editForm.cube_price"></el-input>
                        </el-form-item> -->
                        <!-- <el-form-item  label="采购成本单价：" prop="purchase_amount">
                            <el-input v-model="editForm.purchase_amount"></el-input>
                        </el-form-item> -->
                        <!-- <el-form-item  label="外币单价：" prop="foreign_currency_price">
                            <el-input v-model="editForm.foreign_currency_price"></el-input>
                        </el-form-item> -->
                        <!-- <el-form-item  label="仓库：" prop="warehouse_id">
                            <el-select v-model="editForm.warehouse_id">
                                <el-option v-for="list in warehouseList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <!-- <el-form-item  label="产地：" prop="place_origin">
                            <el-input v-model="editForm.place_origin"></el-input>
                        </el-form-item> -->
                        <el-form-item  label="检尺：" prop="check_status">
                            <el-select v-model="editForm.check_status">
                                <el-option :value="0" label="未检尺"></el-option>
                                <el-option :value="1" label="已检尺"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="币种：" prop="foreign_currency_id">
                            <el-select v-model="editForm.foreign_currency_id" @visible-change="getSelectList('currency')">
                                <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="属性：" prop="attribute_id">
                            <el-select v-model="editForm.attribute_id" @visible-change="getSelectList('attribute')">
                                <el-option v-for="list in selectMap.attribute" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="选色：" prop="color_id" v-if="boardAmericaType">
                            <el-select v-model="editForm.color_id" @visible-change="getSelectList('color')">
                                <el-option v-for="list in selectMap.color" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="备注：" prop="remark">
                            <el-input v-model="editForm.remark"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn" @click="edit([editForm.id])">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="dialogVisibleSet=!dialogVisibleSet">取消</el-button>
                </div>
            </el-dialog>
            <!-- 修改库存END -->
            <!-- 确认入库 START -->
            <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogOneLabel eldialogInWarehouse" width="280px" :modal="false" title="入库" custom-class="full_dialog">
                <div class="clearfix">
                    <el-form>
                        <el-form-item label="仓库:">
                            <el-select class="edit_input" v-model="outWas.warehouse_id" @change="inStockWarehouse" @visible-change="getSelectList('warehouse')">
                                <el-option v-for="list in selectMap.warehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="库位：:">
                            <el-select class="edit_input" v-model="outWas.storage_location_id">
                                <el-option v-for="list in locationList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="库位：">
                            <el-input class="edit_input" v-model="outWas.storage_location" size="mini"></el-input>
                        </el-form-item> -->
                        <el-form-item label="时间：">
                            <el-date-picker class="edit_input" v-model="outtime" type="date" size="mini"></el-date-picker>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="dialogBtnList clearfix" style="padding:0;">
                    <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" style="margin-right:0;" @click="outWasFunc">确定</el-button>
                    <el-button class="funcPublicBtn dialogBtn" @click="dialogVisible = false">关闭</el-button>
                </div>
            </el-dialog>
            <!-- 确认入库 END -->
            <!-- 字段过滤 START -->
            <filter-fields :tableData="filter" scene="inventory.transit" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
            <!-- 字段过滤 END -->
            <!-- 宽度列表START -->
            <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
                <total-widthnew :edit="isCanWidthEdit" :isHidePer="true" :ispost="true" :widthSaleInventoryId="widthSaleInventoryId" :dialogvisible="dialogVisibleWidth" :type="widthObj.widthType" :widthid="widthObj.id" :list="widthObj.widthList" @changeSuccess="getList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>

                <!-- <total-widthnew :edit="true" :isHidePer="true" :ispost="true" :widthSaleInventoryId="widthSaleInventoryId" :list="widthObj.widthList" :type="widthObj.widthType" :widthid="widthObj.id"  @changeSuccess="getList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew> -->
            </el-dialog>
            <!-- 宽度列表END -->
            <!-- 检尺START -->
            <el-dialog v-dialog-drag :visible.sync="dialogVisibleChi" class="eldialog eldialogOneLabel" width="290px" :modal="false" title="检尺" custom-class="full_dialog">
                <div class="">
                    <el-form>
                        <el-form-item label="捆包号:">
                            <el-input class="edit_input" @blur="chiBlur" v-model="chiData.bale_no" placeholder=""></el-input>
                        </el-form-item>
                            <el-form-item label="码单立方:">
                            <el-input class="edit_input" readonly v-model="chiData.original_cube" placeholder=""></el-input>
                        </el-form-item>
                            <el-form-item label="检尺立方:">
                            <el-input class="edit_input" v-model="chiData.check_cube" @input="chiCheckCube" placeholder=""></el-input>
                        </el-form-item>
                            <el-form-item label="销售立方:">
                            <el-input class="edit_input" v-model="chiData.sales_cube" placeholder=""></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="dialogBtnList clearfix" v-if="lock_status==1">
                    <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="openTip(1)">保存并继续</el-button>
                    <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="openTip(0)">保存</el-button>
                    <!-- <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleChi = false">关闭</el-button> -->
                </div>
                <div class="dialogBtnList clearfix" v-else>
                    <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="chiEdit('reset')">保存并继续</el-button>
                    <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="chiEdit">保存</el-button>
                    <!-- <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleChi = false">关闭</el-button> -->
                </div>
            </el-dialog>
            <el-dialog v-dialog-drag :visible.sync="dialogVisibleTip" class="eldialog eldialogOneLabel" width="290px" :modal="false" title="提示" custom-class="full_dialog">
                <div class="" style="">
                    在途资源被锁定，您检尺的同时会同步修改销售单内锁定在途货物的销售立方和挂牌价格，是否确定检尺！
                </div>
                <div class="dialogBtnList clearfix">
                    <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" v-if="tipType==1" @click="chiEdit('reset')">确定</el-button>
                    <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" v-else-if="tipType==0" @click="chiEdit">确定</el-button>
                    <!-- <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleChi = false">关闭</el-button> -->
                </div>
            </el-dialog>
            <!-- 检尺END -->
            <!--execl START-->
            <el-dialog v-dialog-drag title="批量检尺上传" :visible.sync="importDialogVisible" class="eldialog eldialogExcel" :modal="false" width='400px'>
                <div class="text-center"  style="margin-top:20px;">
                    <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".xls,.xlsx">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;">点击上传</em></div>
                        <div class="el-upload__tip" slot="tip"  style="color: #888;margin-top:5px;">只能上传Excel文件</div>
                        <div class="el-upload__tip" slot="tip"  style="color: #888;margin-top:5px;color: rgb(178, 17, 17);padding: 0 46px;">注意：在途资源被锁定时，也可以通过检尺或批量检尺把检尺方数（即销售立方）同步到销售单内</div>
                    </el-upload>
                    <!-- <div class="">
                        <el-link type="primary" @click='downTemplete' style="color:#b21111;font-weight:bold; cursor:pointer;">下载模板</el-link>
                    </div> -->
                </div>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn" @click="importFile">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="importDialogVisible=!importDialogVisible">取消</el-button>
                </div>
            </el-dialog>
            <!--execl END-->
            <!-- 同步销售总宽度 START -->
            <el-dialog v-dialog-drag :visible.sync="salesEditDialog" class="eldialog eldialogOneLabel totalChangeWidth spec" width="450px" :modal="false" title="是否确定修改" custom-class="full_dialog">
                <div class="whole">
                    <el-checkbox v-model="sync_width"
                            class="confirmCheckBox">是否将厚度、长度、厚度mm、长度m的修改同步到销售总宽
                    </el-checkbox>
                </div>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn" @click="synchronization">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="salesEditDialog = false">取消</el-button>
                </div>
            </el-dialog>
            <!-- 同步销售总宽度 END -->
        </div>
</template>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    export default {
        data(){
            return{
                widthSaleInventoryId:"",
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
                categoryScrapType:localStorage.dw_erp_category.indexOf("scrap")!=-1?true:false,
                categoryGlulamType:localStorage.dw_erp_category.indexOf("glulam")!=-1?true:false,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                isShowMore:false,
                dialogVisibleWidth:false,
                widthList:[],
                importDialogVisible:false,
                upload_data : {},
				oss : {
                    host : "",
                },
				file_url : '',
                params:{
                    supplier_id:"",
                    breed_id:"",
                    thickness:"",
                    length:"",
                    grade_id:"",
                    bale_no:"",
                    warehouse_id:"",
                    price_min:"",
                    price_max:"",
                    contract_no:"",
                    bill_lading_no:"",
                    storage_age:"",
                    storage_location:"",
                    remark:"",
                    container_no:"",
                    attribute_id:"",
                    opening_company_id:"",
                    color_id:"",
                    purchase_type:"",
                    check_status:"",
                    original_bale:"",
                    page:1,
                    per_page:50
                },
                last_page:1,
                total:0,
                selectRow:[],
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    attribute_id:[],
                    color_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[]
                },
                selectMap:{
                    port:[],
                    warehouse:[],
                    supplier:[],
                    breed:[],
                    brand:[],
                    grade:[],
                    attribute:[],
                    color:[],
                    opencompany:[],
                    currency:[]
                },
                locationList:[],
                list:[],
                tableCol:[
                    {colName:"采购类型",colKey:"purchase_type_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"资源状态",colKey:"stock_status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"检尺状态",colKey:"check_status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供单号",colKey:"original_bale",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"货权单位",colKey:"opening_company",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"产品图片",colKey:"thumbnail",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isStockImg:true},
                    {colName:"产地",colKey:"place_origin",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"属性",colKey:"attribute",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"选色",colKey:"color",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"厚度",colKey:"original_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"长度",colKey:"original_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"层数",colKey:"layer_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"总宽度",colKey:"original_width_total",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"码单立方",colKey:"original_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"检尺立方",colKey:"check_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"立方差",colKey:"cube_sub",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售状态",colKey:"status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"锁定人",colKey:"locker_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"外币单价",colKey:"foreign_currency_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"采购单价",colKey:"cube_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"挂牌价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"外商单号",colKey:"ex_order_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"库位",colKey:"storage_location",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"目的港",colKey:"purpose_port",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库仓库",colKey:"warehouse",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"预计入库",colKey:"expected_storage_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"预计到港",colKey:"expected_arrival_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"到期日",colKey:"expiry_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                editForm:{
                    id:[],
                    inbound_time:"",
                    bale_no:"",
                    breed_id:"",
                    brand_id:"",
                    original_thickness:"",
                    original_length:"",
                    pieces:"",
                    original_cube:"",
                    sales_price:"",
                    cube_price:"",
                    purchase_amount:"",
                    foreign_currency_price:"",
                    warehouse_id:"",
                    supplier_id:"",
                    contract_no:"",
                    place_origin:"",
                    bill_lading_no:"",
                    port_id:"",
                    container_no:"",
                    original_bale:"",
                    expected_arrival_time:"",
                    expected_storage_time:"",
                    check_status:"",
                    remark:""
                },
                dialogVisibleSet:false,
                dialogVisible:false,
                outWas:{
                    id:[],
                    warehouse_id:"",
                    inbound_time:"",
                    storage_location:"",
                    storage_location_id:""
                },
                outtime:new Date(),
                totalObj:{},
                selectTotalCube:0,
                editIds:[],
                editType:2,//修改  2单个修改 3多个修改
                filterDialogVisible:false,
                filter:"",
                fields:"",
                widthObj:{
                    id:"",
                    widthList:[],
                    widthType:2,//2.码单 3.销售
                },
                chiData:{
                    id:"",
                    bale_no:"",
                    original_cube:"",
                    check_cube:"",
                    sales_cube:""
                },
                dialogVisibleChi:false,
                lock_status:999,
                dialogVisibleTip:false,
                tipType:999,
                isCanWidthEdit:false,
                is_like:false,
                salesEditDialog:false,
                sync_width:false,
                editCategory:false,
                isCategory:0,
                isCategoryNumber:0,
            }
        },
        created(){
            this.getSelectList("port")
            this.getSelectList("warehouse")
            this.getSelectList("supplier")
            this.getSelectList("breed")
            this.getSelectList("brand")
            this.getSelectList("grade")
            this.getSelectList("attribute")
            this.getSelectList("color")
            if(sessionStorage.PURCHASEMIDWAYBOARD){
                this.params.purchase_type = 1;
                sessionStorage.removeItem("PURCHASEMIDWAYBOARD")
            }
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        methods:{
            inStockWarehouse(e){
                this.postFunc("/erp/warehouse.location.select",{warehouse_id:e},res=>{
                    this.outWas.storage_location_id = "";
                    this.locationList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            bachChi(){
                this.importDialogVisible = !this.importDialogVisible;
            },
            chiBlur(){
                this.postFunc("/erp/inventory.get.cube",{bale_no:this.chiData.bale_no},response=>{
                    this.chiData.original_cube = response.data.data.original_cube;
                    this.lock_status = response.data.data.lock_status;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //检尺修改START
            chiCheckCube(val){
                this.chiData.sales_cube=Number(val);
            },
            chiEdit(type){
                this.postFuncLoading("/erp/inventory.transit.check",this.chiData,()=>{
                    if(type=="reset"){
                        this.chiData=this.resetJson(this.chiData)
                    }else{
                        this.dialogVisibleChi=false;
                    }
                    this.tip('检尺成功','success');
                    this.getList()
                    this.dialogVisibleTip = false;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            chi(){
                if(this.selectRow.length>1){
                    this.tip("请选择一件库存商品检尺","warning")
                    return;
                }else if(this.selectRow.length==1&&this.selectRow[0].status==5){
                    this.tip("已售资源无法检尺","warning")
                    return;
                }else{
                    if(this.selectRow.length<1){
                        this.dialogVisibleChi=!this.dialogVisibleChi;
                    }else{
                        if(!this.selectRow[0].isCheck){
                            this.tip("选择商品不可检尺","warning")
                            return;
                        }else{
                            this.lock_status = this.selectRow[0].lock_status
                            let arr = new Array();
                            arr[0] = this.selectRow[0].id;
                            this.chiData.id=arr;
                            this.chiData.bale_no = this.selectRow[0].bale_no;
                            this.chiData.original_cube = this.selectRow[0].original_cube;
                            this.chiData.check_cube = this.selectRow[0].check_cube;
                            this.chiData.sales_cube = this.selectRow[0].sales_cube;
                            this.dialogVisibleChi=!this.dialogVisibleChi;
                        }
                    }
                }
            },
            openTip(type){
                this.tipType = type;
                this.dialogVisibleTip = !this.dialogVisibleTip;
            },
            //检尺修改END
            filterConfirm(){
                this.getList()
            },
            //打印标签
            printTip(){
                if(this.selectRow.length<1){
                    this.tip("请选择打印数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id);
                    })
                    let url = "/labelPrint?ids=" + arr+"&field="+this.params.field+"&sort="+this.params.sort;
                    window.open(url);
                }
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            getSelectWarehouseList(target){
                this.$getSelectWarehouseList(target,this.params,'','transit').then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            batchEdit(){
                if(this.selectRow.length<1){
                    this.tip("请选择库存","warning")
                }else{
                    let flag = true;
                    this.editIds=[];
                    for(let i=0;i<this.selectRow.length;i++){
                        if(!this.selectRow[i].isEdit){
                            flag = false;
                            this.tip("选择商品中有不可修改项","warning")
                            return;
                        }else{
                            this.editIds.push(this.selectRow[i].id)
                        }
                    }
                    if(flag){
                        this.editType=3;
                        this.selectRow.forEach(item=>{
                            if(item.category_id==1){
                                this.editCategory = true;
                            }
                            if(item.category_id==2){
                                this.isCategory = 1;
                                if(item.width.length>1){
                                    this.tip("选择商品中有混包数据","warning")
                                }
                            }
                        })
                        this.dialogVisibleSet=true;
                    }
                }
            },
            //是否确定修改同步
            synchronization(){
                this.isCategoryNumber = 1;
                this.edit();
            },
            edit(){
                if(this.isCategory ==1&&this.isCategoryNumber == 0){
                    this.salesEditDialog=true;
                    return
                }
                if(this.editType==3){
                    this.editForm.id=this.editIds;
                }
                let url = "";
                if(this.editType==2){
                    url = "/erp/inventory.update.one";
                }else{
                    url = "/erp/inventory.update";
                }
                let inbound_time = this.editForm.inbound_time;
                let expected_arrival_time = this.editForm.expected_arrival_time;
                let expected_storage_time = this.editForm.expected_storage_time;
                this.editForm.inbound_time=this.formatTimeZero(this.editForm.inbound_time)
                this.editForm.expected_arrival_time=this.formatTimeZero(this.editForm.expected_arrival_time)
                this.editForm.expected_storage_time=this.formatTimeZero(this.editForm.expected_storage_time)
                if(this.editType==3&&this.isCategory ==1){
                    this.editForm.sync_width = this.sync_width==true?1:0;
                }
                this.postFuncLoading(url,this.editForm,()=>{
                    this.tip('修改成功','success');
                    this.dialogVisibleSet=false;
                    this.salesEditDialog = false;
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                    this.editForm.inbound_time = inbound_time;
                    this.editForm.expected_arrival_time = expected_arrival_time;
                    this.editForm.expected_storage_time = expected_storage_time;
                },()=>{
                    this.editForm.inbound_time = inbound_time;
                    this.editForm.expected_arrival_time = expected_arrival_time;
                    this.editForm.expected_storage_time = expected_storage_time;
                })
            },
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    let arr = new Array();
                    for(let i=0;i<this.selectRow.length;i++){
                        if(this.selectRow[i].isDelete){
                            arr.push(this.selectRow[i].id)
                        }else{
                            this.tip("请选择数据有不可删除项","warning")
                            return;
                        }
                    }
                    this.del(arr)
                }
            },
            del(ids){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/inventory.delete",{id:ids},()=>{
                        this.tip('删除成功','success');
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            outWasFunc(){
                this.$confirm('是否确认入库?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.outWas.id=arr;
                    this.outWas.inbound_time=this.formatTimeZero(this.outtime);
                    this.locationList.forEach(item=>{
                        if(item.id == this.outWas.storage_location_id){
                            this.outWas.storage_location = item.name;
                        }
                    })
                    this.postFuncLoading("/erp/inventory.inbound",this.outWas,()=>{
                        this.tip('入库成功','success');
                        this.dialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            confirm(){
                if(this.selectRow.length<1){
                    this.tip("请选择商品","warning")
                }else{
                    this.outWas.warehouse_id = this.selectMap.warehouse.length>0?this.selectMap.warehouse[0].id:'';
                    if(this.outWas.warehouse_id){
                        this.inStockWarehouse(this.outWas.warehouse_id);
                    }
                    this.dialogVisible=true;
                }
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.getList();
            },
            //表格排序
            sortTable(sort){
                this.params.field = sort.order ? sort.prop:'';
                this.params.sort = sort.order == "ascending"?"asc":sort.order == "descending"?"desc":"";
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.params.is_like = this.is_like;
                this.$postColumnList("/erp/inventory.transit",this.params,res=>{
                    this.last_page=parseInt(res.data.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.totalObj=res.data.data.total;
                    this.totalObj.cube_total=this.keepLimit(this.totalObj.cube_total)
                    this.list=res.data.data.data.data;
                    this.list.forEach((item,index)=>{
                        if(item.expected_arrival_time!=0){
                            this.list[index].expected_arrival_time = this.formatTime(item.expected_arrival_time+"000")
                        }else{
                            this.list[index].expected_arrival_time = "";
                        }
                        if(item.actual_arrival_time!=0){
                            this.list[index].actual_arrival_time = this.formatTime(item.actual_arrival_time+"000")
                        }else{
                            this.list[index].actual_arrival_time = "";
                        }
                        if(item.expected_storage_time!=0){
                            this.list[index].expected_storage_time = this.formatTime(item.expected_storage_time+"000")
                        }else{
                            this.list[index].expected_storage_time = "";
                        }
                        // if(item.expiry_time!=0){
                        //     this.list[index].expiry_time = this.formatTime(item.expiry_time+"000")
                        // }else{
                        //     this.list[index].expiry_time = "";
                        // }
                        if(item.isRed){
                            item.baseColor = "#ff0000";
                        }
                        this.list[index].thickness = this.keepLimit(item.thickness)
                        this.list[index].length = this.keepLimit(item.length)
                        // if(item.purchase_type==2){
                        //     item.isCanSelection=true;
                        // }else{
                        //     item.isCanSelection=false;
                        // }
                        // this.list[index].original_width_total = parseInt(item.original_width_total)
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        // if(item.colKey=="status_text"||item.colKey=="stock_status_text"){
                        //     if(this.fields.indexOf(",status,")!=-1){
                        //         item.isShow=true;
                        //     }
                        // }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                if(obj.name=="original_width_total"){
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            this.widthObj.widthList = item.width;
                            this.widthObj.id = item.id;
                            this.isCanWidthEdit = obj.row.isEdit;
                            this.dialogVisibleWidth = true;
                            this.widthSaleInventoryId = item.id;
                        }
                    })
                }
            },
            getTableDelete(id){
                this.del([id])
            },
            getTableSee(id){
                this.pl(id)
            },
            getTableEdit(id){
                this.list.forEach(item=>{
                    if(item.id==id){
                        this.editForm=JSON.parse(JSON.stringify(item));
                        this.editForm = this.clearZero(this.editForm)
                        // let arr = new Array();
                        // arr[0]=item.id;
                        this.editForm.id=item.id;
                        // if(item.category_id==1){
                            this.editCategory = true;
                        // }
                    }
                })
                this.dialogVisibleSet=true;
            },
            getRow(row){
                this.selectRow=row;
                let total=0;
                this.selectRow.forEach(item=>{
                    total+=parseFloat(item.original_cube)
                })
                this.selectTotalCube=this.keepLimit(total);
            },
            //批量检尺导入
            handleSuccess(res) {
                this.file_url = res.data.base_url;
				this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            importFile(){
                this.analysis('/erp/inventory.batch.check',this.file_url,"","","",response=>{
                    if (response.data.code == 0) {
                        this.tip("上传成功","success")
                        this.getList()
                        this.importDialogVisible=false;
                    }else{
                        this.tip(response.data.message,"warning")
                    }
                })
            },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                })
            }
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "dialogVisible":function(){},
            "dialogVisibleSet":function(val){
                if(!val){
                    this.editForm=this.resetJson(this.editForm);
                    this.editIds=[];
                    this.editType=2;
                    this.editCategory = false;
                    this.isCategory = 0;
                    this.sync_width = false;
                    this.isCategoryNumber = 0;
                }
            },
        }
    }
</script>
<style scoped>
    .dialogBtnList {padding:10px 0;}
    .eldialog.eldialogOneLabel /deep/ .el-form-item .el-form-item__content{width:160px;}


    /* .templete >>> .eldialogExcel .el-dialog__body{padding:10px;}
    .templete >>> .eldialogExcel .text-center{margin-top:0!important;}
    .templete >>> .eldialogExcel .el-upload{display: block;} */
</style>
